export default __webpack_public_path__ + "static/media/sass-logo.a96ca68c.svg";